import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { OnButtonClick } from './EmptyStateLayout/types';

type NoNumericValuesInFieldsDoqProps = {
  doqType: DoqType;
  onChangeFieldsClick: OnButtonClick;
  i18nLocale: I18nLocale;
};

const NoNumericValuesInFieldsDoqBase = ({
  doqType,
  onChangeFieldsClick,
  i18nLocale,
}: NoNumericValuesInFieldsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noNumericValuesInFields.title',
          'There is no data to show'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noNumericValuesInFields.message',
          'The context workspace or component has no value in the bubble size, X or Y-axis fields. Change the selected Bubble Chart fields or add values to the fields.'
        )}
        buttonLabel={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noNumericValuesInFields.changeFields',
          'Change fields'
        )}
        onButtonClick={onChangeFieldsClick}
      />
    </EmptyStatesDoqContainer>
  );
};

export const NoNumericValuesInFieldsDoq = connect(
  NoNumericValuesInFieldsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
